import { type CSSProperties, type ReactNode } from "react";

interface CardProps {
  className?: string;
  style?: CSSProperties;
  variant?: "default" | "dark" | "subtle";
  children: ReactNode;
}

export function Card({ className = "", style, variant = "default", children }: CardProps) {
  return (
    <div className={`xpn-card xpn-card--${variant} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
